import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export default class MuiSxStyles {

  static getRowColor = (index: number, theme: Theme) => {
    return index % 2 === 0 ? theme.palette.background.default : theme.palette.grey[100];
  }

  /**
   * merges multiple SxProps<Theme> objects into one SxProps<Theme> object
   * @param sxStyles Pass multiple SxProps<Theme> separated by comma eg: (SxStyles.frostedGlass, SxStyles.bottomShadow, etc,...)
   * @returns merged SxProps<Theme> object
   */
  static merge(...sxStyles: SxProps<Theme>[]): SxProps<Theme> {
    return Object.assign({}, ...sxStyles);
  }

  // TODO: refactor each style into its own separate files

  static addAlpha = (color: string, value: number): string => {
    return alpha(color, value);
  }

  static dialogPaper: SxProps<Theme> = {
    border: (t) => `1px solid ${t.palette.mode === 'dark' ? t.palette.primary.light : t.palette.primary.light}`,
  }

  static dialogHeader: SxProps<Theme> = {
    paddingBlock: 1,
    paddingInline: 0,
    backgroundColor: (t) => {
      let darkGloss = t.palette.background.paper;
      let lightGloss = alpha(t.palette.primary.light, 0.05);
      return t.palette.mode === 'dark' ? darkGloss : lightGloss;
    },
  }

  static dialogContent: SxProps<Theme> = {
    m: 0, p: 0,
    // borderTop: (t) => `1px solid ${t.palette.mode === 'dark' ? t.palette.primary.light : t.palette.primary.light}`,
    // borderBottom: (t) => `1px solid ${t.palette.mode === 'dark' ? t.palette.primary.light : t.palette.primary.light}`,
    boxShadow: (t) => t.palette.mode === 'dark' ? 'rgb(19 47 76) 0px -1px 1px' : 'rgba(0, 89, 178, 0.24) 0px -1px 1px',
    backgroundColor: (t) => t.palette.mode === 'dark' ? t.palette.background.default : '#EFEFF4',
  }

  static dialogFooter: SxProps<Theme> = {
    boxShadow: (t) => t.palette.mode === 'dark' ? 'rgb(19 47 76) 0px -1px 1px' : 'rgba(0, 89, 178, 0.24) 0px -1px 1px',
    backgroundColor: (t) => {
      let darkGloss = t.palette.background.paper;
      let lightGloss = alpha(t.palette.primary.light, 0.05);
      return t.palette.mode === 'dark' ? darkGloss : lightGloss;
    },
  }

  static iconButtonGroup: SxProps<Theme> = {
    border: (t) => `1px solid ${t.palette.divider}`,
    borderRadius: '46px',
    width: 'auto',
    paddingInline: 0,
  }


  static frostedGlassMenu: SxProps<Theme> = {
    backdropFilter: 'blur(128px)',
    border: (theme) => `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.divider}`,
    boxShadow: (theme) => `${theme.palette.mode === 'dark' ? theme.palette.info.dark : theme.palette.info.light} 0px -1px 1px inset`,
    backgroundColor: (theme) => {
      let darkGloss = alpha(theme.palette.background.paper, 1);
      let lightGloss = alpha(theme.palette.background.paper, 1);
      return theme.palette.mode === 'dark' ? darkGloss : lightGloss;
    },
  };

  static frostedGlassBackdrop: SxProps<Theme> = {
    backdropFilter: 'blur(4px)',
    backgroundColor: (theme) => {
      let darkGloss = alpha(theme.palette.background.paper, 0.50);
      let lightGloss = alpha(theme.palette.background.paper, 0.70);
      return theme.palette.mode === 'dark' ? darkGloss : lightGloss;
    },
  };

}